export const alphanumericAndSpecialCharactersAndParenthesisRule = {
  regex: new RegExp(/^[0-9a-zA-Z,\-_,'`àâäéèêëïîôöùûüÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸçæÆœŒ() ]*$/),
  message: 'myself.formulaire.errors.caracteresNonAutorisesAvecChiffresParentheses',
}
export const alphanumericAndSpecialCharactersRule = {
  regex: new RegExp(/^[0-9a-zA-Z,\-_,'àâäéèêëïîôöùûüÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸçæÆœŒ ]*$/),
  message: 'myself.formulaire.errors.caracteresNonAutorisesAvecChiffres',
}
export const alphabeticAndSpecialCharactersRule = {
  regex: new RegExp(/^[a-zA-Z,\-_,'àâäéèêëïîôöùûüÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸçæÆœŒ ]*$/),
  message: 'myself.formulaire.errors.caracteresNonAutorises',
}
export const noSpaceAllowedRule = {
  regex: new RegExp(/^[^( \-_,)](?!.* {2}).*[^( \-_,)]$|^$/),
  message: 'myself.formulaire.errors.noSpacesAllowed',
}
